<mat-dialog-content class="app-valuable-dialog__content">
    <div>
        <h2 mat-dialog-title class="app-valuable-dialog__title">
            {{
                data.valuable.id
                    ? ('apps.patient.overview.editValuable' | translate)
                    : ('apps.patient.overview.addValuable' | translate)
            }}
        </h2>
        <app-valuable-form
            [formGroup]="valuableForm"
            [isBedSideMode]="data.isBedSideMode"
            [isActive]="true"
        ></app-valuable-form>
    </div>

    <div class="app-valuable-dialog__actions">
        <button mat-button class="app-valuable-dialog__cancel" color="primary" mat-dialog-close>
            {{ 'apps.patient.overview.dialogCancel' | translate }}
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="submitChange()">
            {{ 'apps.patient.overview.dialogSave' | translate }}
        </button>
    </div>
</mat-dialog-content>
